import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

let termsOne = [
    '1. Where Can I Find Your Privacy Policy?',
    '2. Acceptable Use',
    '3. The Platform',
    '4. Customer Accounts and Security',
    '5. Information About Service Professionals',
    '6. Making a Reservation',
    '7. Payments and Authorization',
    '8. Cancelling or Rescheduling a Reservation',
    '9. Promotions',
    '10. Links',
    '11. Intellectual Property Notice',
    '12. Communications from ezPro',
    '13. Availability, Termination, and Suspension',
    '14. Children’s Privacy',
    '15. Class Action Waiver',
    '16. Arbitration and Dispute Resolution',
    '17. Disclaimers',
    '18. Limitation of Liability',
    '19. Indemnity',
    '20. Users Outside of the United States',
    '21. Changes to These Terms of Use',
    '22. Miscellaneous',
    '23. Contact Us'
  ]
  
  let termsTwo = [
    '(i) use (including make any copies of) the Platform beyond the scope of the license granted in Section 3;',
    '(ii) modify,   reverse-compile,   reverse-engineer   translate,   adapt,   or   otherwise   create derivative works or improvements, whether or not patentable, of the Platform or any part thereof;',
    '(iii) copy,   reproduce,   distribute,   republish,   download,   display,   post   or   transmit   the Platform in any form except as expressly permitted in these;',
    '(iV) reverse engineer, disassemble, decompile, decode, or otherwise attempt to derive or gain access to the source code of the Platform or any part thereof;',
    '(v) remove,   delete,   alter,   or   obscure   any   trademarks   or   any   copyright,   trademark, patent, or other intellectual property or proprietary rights notices provided on or with the Platform;',
    '(vi) pload,   transmit,   or   distribute   any   computer   viruses,   worms,   or   any   software intended to damage or alter the Platform; ezPro’s software or data; a computer or communications network; a computer or handheld mobile device; data; or any other system, device, or property;',
    '(vii) interfere with, disrupt, or attempt to gain unauthorized access to the servers or networks   connected   to   the   Platform   or   violate   the   regulations,   policies,   or procedures of such networks; and'
  ]

class TermsOfUseAlert extends React.Component {
    handleClose = () => {
        this.props.close();
    };

    termOfUseContent = () => {
        var description={
            margin: 5,
            alignSelf: 'center',
            fontSize: 17,
            paddingHorizontal: 10
        };
    
        var textUnderline= {
          textDecorationLine: 'underline',
          fontWeight: '700'
        }; 
        var textBold= {
          fontWeight: '700'
        };
        var mb10= {
          marginBottom: 10,
          marginTop: 10
        };
        var mb20= {
          marginBottom: 20
        };
        var mt40= {
          marginTop: 40
        }
        return (
            <div>
                <p style={{
                    textAlign: 'center',
                    fontSize: 18,
                    fontWeight: '700'
                }}>
                    ezPro Home Services
                </p>
                <p style={{
                    textAlign: 'center',
                    fontSize: 18,
                    fontWeight: '700'
                }}>
                    Terms of use
                </p>

                <div style={{
                    margin: 20
                }}>
                    <p style={mb20}>
                        Last updated: June 22, 2022
                    </p>
                    <p style={mb10}>
                        Thank you for vising the ezPro Home Services (“ezPro”) website, which is owned and operated
                        by PoM Home Services, Inc.  Please carefully read these Terms of Use; all the terms, conditions,
                        and notices contained or referenced herein; and all of our other operating rules and policies
                        (including the ezPro Privacy Policy, which can be found here) before accessing our website
                        (“Site”) and mobile application (“App”), collectively referred to as the Platform.
                    </p>
                    <p style={mb10}>
                        These Terms of Use (or “Terms”) are a legal and binding agreement between You and ezPro and
                        govern Your access to, and use of the Platform.
                    </p>
                    <p style={mb10}>
                        It is important that you carefully read and understand these Terms.  The Platform is available for
                        your   use   on   the   condition   that   you   agree   to   the   terms   explained   below.     This   is   a   binding
                        agreement.   If you do not agree to all of the Terms, do not access or use the Platform.   By
                        accessing or using the Platform, you signify your agreement to be bound by these Terms.  We
                        may amend these Terms from time to time at our discretion.  We will post a notice on the Site
                        any time these Terms have been changed or otherwise updated.   Please review these Terms
                        periodically, and if at any time you find these Terms unacceptable, you must immediately leave
                        and cease all use of the Platform.
                    </p>
                    <p style={mb10}>
                        These Terms of Use include the following
                    </p>
                    <div style={{
                        marginBottom: 20
                    }}>
                        {termsOne.map((term) => {
                            return (
                                <div style={{
                                    marginLeft: 50,
                                }}>
                                    <p style={{
                                        fontWeight: '700'
                                    }}>{term}</p>
                                </div>
                            )
                        })}
                    </div>
                    <p style={{...textUnderline, ...mb10}}>
                        1. Where Can I Find Your Privacy Policy?
                    </p>
                    <p>
                        Our Privacy Policy governs the use of information collected from or provided by you through the
                        Platform.     A   complete   statement   of   our   current   Privacy   Policy   can   be   found   at:
                        https://ezprohome.com/page/privacy-policy.     Our   Privacy   Policy   is   incorporated   herein   by
                        reference
                    </p>

                    <p style={{...textUnderline, ...mb10}}>
                        2. Acceptable Use
                    </p>
                    <p>
                        Your use of the Platform must not violate any applicable laws, including export control laws, or
                        other   laws   in   Your   jurisdiction.     You   are   responsible   for   making   sure   that   your   use   of   the
                        Platform follows the law and any applicable regulations
                    </p>
                    <p>
                        You further agree that you will not under any circumstances upload, post, host, or transmit any
                        Content that: is discriminatory, obscene, libelous, defamatory, or fraudulent; contains or installs
                        any active malware or exploits, or uses our platform for exploit delivery (such as part of a
                        command and control  system);  or infringes on any proprietary right  of any party, including
                        patent, trademark, trade secret, copyright, right of publicity, or other rights. You agree not to
                        reproduce, duplicate, copy, sell, resell or exploit any portion of the Platform, use the Platform, or
                        access to the Platform without our express written permission.
                    </p>
                    <p>
                        The rights granted to you by these Terms are subject to the following restrictions.  You shall not
                        directly or indirectly:
                    </p>
                    <div >
                        {termsTwo.map((term) => {
                            return (
                                <div style={{
                                    marginLeft: 30
                                }}>
                                    <p style={{
                                        marginBottom: 10
                                    }}>{term}</p>
                                </div>
                            )
                        })}
                    </div>
                    <p><p style={textBold}>Non-Circumvention.</p> You   agree   not   to   contact   any   Service   Pro   for   automobile   or   home
                        maintenance services other than through the Platform (i.e. not to circumvent the Platform)</p>

                    <p><p style={textBold}>Unauthorized Use.</p> You may not connect to or use the Platform in any way that is not expressly
                        permitted by these Terms.   You acknowledge and agree that You are solely responsible, and
                        ezPro has no responsibility or liability to you or any other person or entity, for any breach by
                        You of these Terms of Use or for the consequences of any such breach.  ezPro may immediately
                        terminate its relationship with you or may suspend your account immediately if it determines you
                        are using the Platform in any manner contrary to the restrictions found in these Terms of Use</p>

                    <p><p style={textBold}>Updates to the Platform.</p> YAny future release, update, or other addition to functionality of the
                        Platform shall be subject to these Terms.</p>

                    <p style={{...textUnderline, ...mb10}}>
                        3. The Platform
                    </p>
                    <p><p style={textBold}>Reservations   and   Services.</p> The   Platform   enables   Customers   to   arrange   and   schedule
                        reservations   for   home   and   automobile   maintenance   services   provided   by   third-party   Service
                        Pros.</p>

                    <p><p style={textBold}>Software License.</p>  Subject to and conditioned upon your strict compliance with these Terms,
                        ezPro hereby grants you a non-exclusive, non-transferable, non-sublicensable limited license to
                        use the Platform solely as set forth in this Section 3 and subject to all conditions and limitations
                        set forth in this Section 3 or elsewhere in these Terms.</p>

                    <p style={{...textUnderline, ...mb10}}>
                        4. Customer Accounts and Security
                    </p>
                    <p><p style={textBold}>Customer Account.</p>  To access certain aspects of the Platform, you must create and maintain an
                        Account.   You can create an Account by completing the registration process on the Platform.
                        You may be required to provide information about yourself as part of the registration process or
                        your continued use of the Platform. You agree that any registration information that you submit
                        to ezPro will be correct, accurate and up-to-date.  You shall not select or use as a username (a) of
                        another person with the intent to impersonate that person; (b) subject to any rights of a person
                        other   than   you   with   appropriate   authorization;   or   (c)   that   is   otherwise   offensive,   vulgar   or
                        obscene.</p>

                    <p><p style={textBold}>Customer Account Security. </p>  Maintaining your account security is very important.   You are
                        solely   responsible   for   maintaining   the   confidentiality   of   your   account   password   and   for   all
                        activities that are conducted via your account.   You agree to notify ezPro immediately if you
                        become aware of any unauthorized use of your password or of your account.   Accounts are
                        registered personally and may not be transferred at any time under any circumstances.   You
                        should not share your account information with, or disclose your password to, anyone else.</p>

                    <p><p style={textBold}>Customer   Content.</p> You   are   entirely   responsible   for   any   Content   you   submit   to   ezPro.
                        “Content”   refers   to   content   featured   or   displayed   through   the   Platform,   including   without
                        limitation   text,   data,   articles,   images,   photographs,   graphics,   software,   designs,   features,   and
                        other materials.   The Content you submit is and will be considered non-confidential and non-
                        proprietary. You acknowledge and agree that you waive any rights that you may have in any
                        territory with respect to any Content you submit to ezPro, including but not limited to the right to
                        be attributed as the author of the Content.  You promise that: (a) you own or have acquired all of
                        the rights in and to Content you submit to ezPro, and (b) the Content you submit does not
                        infringe the intellectual property rights, privacy rights, publicity rights, or any other legal rights
                        of any third party.  We may, but are not required to, monitor and review the Content you submit.
                        We do not endorse or control the Content transmitted or posted on our Platform and therefore are
                        not responsible for it.</p>

                    <p><p style={textBold}>Deactivation by You.</p> You have the right to deactivate your account at any time from your
                        profile. We may maintain a record of your account and reservation history after deactivation.</p>

                    <p style={{...textUnderline, ...mb10}}>
                        5. Information About Service Professionals
                    </p>
                    <p>
                        Service Professionals.  Service Professionals (“Service Pros”) are independent contractors and
                        not employees, partners, agents, joint ventures, or franchisees of ezPro.  Service Pros are
                        required to hold a valid license to perform the maintenance services they provide and to comply
                        with all applicable federal, state, and local laws, rules and regulations.  ezPro may, but is not
                        required to, conduct background checks on Service Pros.  While ezPro may conduct background
                        checks and monitor their licensing status, ezPro shall not be liable or responsible for any services
                        provided by Service Pros, or any errors or misrepresentations made by any of them.  Although
                        ezPro (a) displays information about Service Pros, (b) may conduct background checks on
                        Service Pros, and (c) collects payments for Service Pros, such actions do not in any way
                        constitute ezPro’s sponsorship or approval of any Professional.  ezPro does not endorse or
                        recommend any Service Pro, and you agree that ezPro is not responsible for the accuracy or
                        completeness of information displayed through the Platform with respect to such Service Pros.
                        You further acknowledge that ezPro does not supervise, direct, control, or monitor a Service
                        Pro’s provision of services and expressly disclaim any responsibility or liability for the services
                        performed.
                    </p>
                    <p><p style={textBold}>
                        Third-Party Service Pro Terms.</p>
                        If you make a reservation through the Platform, you agree
                        that you will be bound by the applicable Service Pro’s business terms and conditions and any
                        other applicable rules or policies of such Service Pro.  Your interactions with the Service Pro are
                        at your own risk, and ezPro shall not be liable with respect to the acts, omissions, errors,
                        representations, warranties, breaches or negligence of any Service Pro or for any personal
                        injuries, death, property damage, or other damages or expenses resulting from Your interactions
                        with any Service Pro.

                    </p>
                    <p style={{...textUnderline, ...mb10}}>
                        6. Making a Reservation.
                    </p>
                    <p>
                        By reserving a reservation with us, you: (i) agree to immediately pay for the services you have
                        booked, (ii) represent that you are an authorized user of the account used to make the reservation,
                        and (iii) represent that you are of legal age to reserve a reservation and authorize payment.  Each
                        reservation that you reserve with us constitutes an offer to immediately pay for services to be
                        provided at a future date.  If you do not receive a message from us confirming your reservation,
                        please contact our Customer Service department at admin@ezprohome.com before attempting to
                        make the reservation again.
                    </p>

                    <p><p style={textBold}>Verification. </p>When you make a reservation, we may verify certain information before your
                        reservation   can   be   finalized,   including   your   personal   information,   payment   information,   and
                        creditworthiness.</p>

                    <p><p style={textBold}>Reservation Issues.</p> Although we strive to accept all valid reservations, we reserve the right to
                        limit, modify, deny or cancel any reservation for any reason, including if: (i) we discover an
                        error, inaccuracy, or omission in pricing and/or other information about the service or receive
                        insufficient or erroneous billing, payment and information; (ii) we suspect a reservation has been
                        reserved using stolen payment card information or otherwise appears to be connected to fraud,
                        unauthorized reselling or another violation of these Terms, (iii) the services reserved through the
                        reservation   become   unavailable,   (iv)   the   reservation   is   connected   with   a   previous   payment
                        dispute, or (v) the reservation is associated with a Customer whom we suspect of abusing the
                        cancelation policy set forth in Section 8 of these Terms of Use or of making fraudulent claims
                        related to the quality of the services provided or other false claims.</p>

                    <p><p style={textBold}>Text and Telephone Communications.</p> WYou agree that ezPro and the Service Pro assigned to
                        your reservation may contact you via telephone, email, and text message (including automated
                        messaging) using any contact information you provide to us.  You understand that you may opt
                        out of receiving emails, text messages, and/or telephone calls from us at any time through your
                        Account   or   by   emailing   us   at  admin@ezprohome.com. You   must   consent   to   receive
                        communications via telephone in order to reserve a reservation.</p>

                    <p style={{...textUnderline, ...mb10}}>
                        7. Payments and Authorization
                    </p>
                    <p><p style={textBold}>Fees and Payments.</p> All Fees are set forth on the Platform and are subject to change at any time
                        without notice.  Except as otherwise expressly set forth herein or as expressly approved by ezPro
                        in writing in its sole discretion, all payments made are final and non-refundable and a Customer
                        shall not have the right to cancel their/its purchase for any reason.   You understand and agree
                        that, while you are free to provide additional payment as a gratuity to any Service Pro who
                        provides services, you are under no obligation to do so.</p>

                    <p><p style={textBold}>Methods of Payment and Credit Card Terms.</p> All payments must be made through your Visa,
                        MasterCard   or   American   Express   (or   other   form   of   payment   specifically   accepted   on   the
                        Platform) and also be in United States dollars.   We currently do not accept cash, personal or
                        business checks, or any other payment form through the Platform, although in the future we may
                        change this policy. Your card issuer agreement governs your use of your designated card, and
                        you must refer to that agreement and not these Terms to determine your rights and liabilities as a
                        cardholder.  You hereby represent and warrant that you will not use any credit card or other form
                        of payment unless you have all necessary legal authorization to do so.  YOU, AND NOT US,
                        ARE   RESPONSIBLE   FOR   PAYING   ANY   UNAUTHORIZED   AMOUNTS   BILLED   TO YOUR CREDIT CARD BY A THIRD PARTY. You agree to pay all fees and charges incurred
                        in connection with your reservation (including any applicable taxes) at the rates in effect when
                        the charges were incurred.</p>

                    <p><p style={textBold}>Unless You notify us of any discrepancies within 60 days after they first appear on your
                        credit card statement, you agree that they will be deemed accepted by you for all purposes.</p> If we do not receive payment from your credit card issuer or its agent, you agree to pay all
                        amounts due upon demand by us or its agents. </p>

                    <p><p style={textBold}>Failed Transactions.</p> In   the   event   that   ezPro   is   unable   to   successfully   charge   any   linked
                        payment instrument, ezPro will notify you via email and/or within the Platform, and you will be
                        unable to initiate further reservations with your account.   Upon ezPro’s notification to you of
                        such failure, you agree to link a new, valid payment instrument as soon as possible but in any
                        event within 5 business days.  Your account may be disabled until a valid payment instrument is
                        provided and the outstanding uncharged balance is resolved by ezPro.  ezPro is not responsible
                        for any charges imposed by the issuer of your payment instrument as a result of any failed charge
                        by ezPro.   To the extent that ezPro is unable to successfully charge any payment instrument
                        linked   to   your   account   as   payment   for   authorized   transactions   for   more   than   30   days,   you
                        understand and agree that ezPro may employ a collection agency or other business in an effort to
                        collect any outstanding debts and fees associated with your account, and you will not contest the
                        use   of   a   third   party   to   collect   the   debt   and   fees   owed   to   ezPro.     You   agree   that   you   are
                        responsible for any legal, court, arbitration, or collection agency fees associated with rectifying
                        your account and all monies owed thereunder.  You agree that ezPro, or any agency or business
                        employed by ezPro, has the right to contact you via telephone or email or in person using the
                        information you provided upon registration or during any contact with ezPro, in an effort to
                        collect any monies and fees owed under your account, whether specifically referenced in these
                        Terms of Use or not, and such contact may be made in a manual or automated fashion.</p>

                    <p><p style={textBold}>Taxes. </p>Sales   taxes,   or   other   taxes,   customs,   import/export   charges,   or   similar   governmental
                        charges are not included in the price of the reservation.  You are responsible for paying any such
                        taxes or charges imposed on your reservation, including, but not limited to, sales, use or value-
                        added taxes.  We shall automatically charge and withhold the applicable tax where required by
                        law.</p>

                    <p><p style={textBold}>Authorization </p> You authorize ezPro to charge all sums for reservations that You make to the
                        payment method designated in Your Account.  When You reserve a reservation through ezPro, a
                        temporary pre-authorization hold is placed on Your designated payment method to verify that the
                        card is valid and has funds available for Your intended purchase.   The amount of this pre-
                        authorization hold may be greater or less than the reservation total quoted at checkout.  However,
                        Your payment will be captured up to twenty-four (24) hours after Your reservation is confirmed.
                        In the event that the pre-authorization is greater than the final amount, the difference will be
                        released after the Services have been fully performed; depending on Your bank, it may take up to
                        five (5) business days to receive access to these released funds.   EzPro also places an initial
                        temporary   pre-authorization   hold   on   each   new   payment   method   You   add   to   Your   Account.
                        EzPro reserves the right to request additional information from You if we have reason to believe,
                        in our sole discretion, that a payment method may be fraudulent.</p>

                    <p style={{...textUnderline, ...mb10}}>8. Cancelling or Rescheduling a Reservation</p>
                    <p><p style={textBold}>Cancellations.</p> If you choose to cancel a reservation, and ezPro receives your cancellation more
                        than twenty-four (24) hours prior to the time scheduled for the reservation, you will receive a
                        refund to your account (unless you have previously rescheduled the reservation—see below). If
                        you cancel with less than twenty-four (24) hours’ notice (a “Late Cancel”), ezPro will retain a
                        seventy-nine dollar ($79) cancellation fee.   If You need to Late Cancel, you must do so by
                        calling us at (916) 496-3133.  You are not permitted to Late Cancel through the Platform or
                        via email.</p>

                    <p><p style={textBold}>Rescheduling.</p> You may reschedule a reservation up to twenty-four (24) hours in advance of the
                        appointment time at no charge.  If you reschedule less than twenty-four (24) hours in advance of
                        the reservation (a “Late Reschedule”), a $79 rescheduling fee will be charged. If You need to
                        Late Reschedule, you must do so by calling us at (916) 496-3133.  You are not permitted to
                        Late Reschedule through the Platform or via email.</p>

                    <p style={{...textUnderline, ...mb10}}>9. Promotions</p>
                    <p>We may, in our sole discretion, create discounts and promotional codes that may be redeemed
                        for promotional value in your account subject to any additional terms that we establish on a per-
                        promotional-code   basis.     Promotional   codes   may   only   be   used   once   per   account.     Only
                        promotional codes sent to you through official ezPro communications channels are valid.  You
                        agree that promotional codes: (i) must be used for the intended audience and purpose, and in a
                        lawful manner; (ii) may not be duplicated, sold or transferred in any manner, or made available
                        to the general public (whether posted to a public forum or otherwise), unless expressly permitted
                        by us; (iii) may be disabled by us at any time for any reason without liability to us; (iv) may only
                        be used pursuant to the specific terms that we establish for such promotional code; (v) have no
                        monetary value and are not redeemable for cash or any cash equivalent; and (vi) may expire prior
                        to Your use.</p>

                    <p style={{...textUnderline, ...mb10}}>10. Links</p>
                    <p>
                        The Platform may contain links to websites operated by other parties. ezPro provides these links
                        to other websites as a convenience.   Use of these websites is at your own risk.   The linked
                        websites are not under ezPro’s control, and we are not responsible for the content available on
                        the   other   websites.     We   do   not   promise   that   the   contents   of   any   linked   site   are   accurate,
                        compliant with local, state or federal law, including any intellectual property laws.  Such links do
                        not imply our endorsement of information or material on any other website, and we disclaim all
                        liability with regard to your access to and use of such linked websites
                    </p>


                    <p style={{...textUnderline, ...mb10}}>11. Intellectual Property Notice</p>
                    <p>
                        {`ezPro, as well as our vendors and agents, retains ownership of all intellectual property rights of
any kind related to the Platform.   You should assume that everything you see or read on the
Platform is proprietary information protected by copyright or trademark unless otherwise noted
and may not be used except with the written permission from ezPro.  We reserve all rights that
are not expressly granted to you under these Terms or by law.  The look and feel of the Platform
is our copyright.  All rights reserved.  You may not duplicate, copy, or reuse any portion of the
HTML/CSS,   Javascript,  or   visual   design   elements   or   concepts   without   express   written
permission from ezPro.

All   trademarks,   service   marks,   trade   names,   logos   and   trade   dress,   whether   registered   or
unregistered   (“Marks”)   that   appear   on   Platform   are   proprietary   to   ezPro   or   such   Marks’
respective owners.  You may not display or reproduce the Marks other than with prior written
consent from ezPro, and you may not remove or otherwise modify any trademark notices from
any content available on or through the Platform.  The Marks are protected by trademark, trade
dress, copyright, and various other intellectual property rights and unfair competition laws.`}
                    </p>


                    <p style={{...textUnderline, ...mb10}}>12. Communications from ezPro</p>
                    <p>
                        We use email and other electronic means to stay in touch with our Users.     For contractual
                        purposes, You (1) consent to receive communications from us in an electronic form via any
                        email address You provide to us or to our service providers and (2) agree that all terms of use,
                        agreements, notices, policies, and other communications that we provide to you electronically
                        satisfy any legal requirement that those communications would satisfy if they were on paper.
                    </p>


                    <p style={{...textUnderline, ...mb10}}>13. Availability, Termination, and Suspension</p>
                    <p>
                        {`We make no representations and provide no warranties that:
• the   Platform   will   be   made   available   at   any   specific   time   or   from   any   specific
geographical location;
• Your access to the Platform will be continuous or uninterrupted; or
• the Platform will be accessible or optimized on all browsers, computers, tablets, phones
or viewing platforms.
We reserve the right to suspend access to all or part of the Platform for any reason, including for
business   or   operational   reasons,   such   as   improving   the   appearance   or   functionality   of   the
Platform, content updates, periodic maintenance, or to resolve any issues that we become aware
of.   Wherever we anticipate that we need to suspend access to the website for a considerable
period of time, we will try to provide you with prior notice where reasonably practicable.
Our Platform is provided for users in the United States.  Although it may be possible to access
the Platform from other countries, we make no representation that it is compliant with any legal
requirements   in   force   in   any   jurisdiction   other   than   the   United   States,   or   that   the   content
available on the Site will be appropriate for users in other countries or states
ezPro has the right to: (i) suspend or terminate your access to all or any part of the Platform any
time and/or (ii) suspend or terminate your account, with or without cause, with or without notice,
effective immediately.  ezPro reserves the right to refuse service to anyone for any reason at any
time.   All provisions of these Terms which by their nature should survive termination shall[{{type}} Annotation][{{type}} Annotation]
survive termination, including, without limitation, ownership provisions, warranty disclaimers,
indemnity, limitations of liability, class action waiver, and arbitration agreement.`}
                    </p>


                    <p style={{...textUnderline, ...mb10}}>14. Children’s Privacy</p>
                    <p>
                        You may not use the Platform if you are under sixteen (16) years of age.  If you use or engage
                        with the Platform and are between the ages of thirteen (16) and eighteen (18) years of age, you
                        must have your parent’s or legal guardian’s permission to do so.  By using or engaging with the
                        Platform,   you   also   acknowledge   and   agree   that   you   are   permitted   by   your   jurisdiction’s
                        applicable law to use and/or engage with the Platform.
                    </p>


                    <p style={{...textUnderline, ...mb10}}>15. Class Action Wavier</p>
                    <p><p style={textBold}>This is a Class Action Waiver.  You cannot bring a class action lawsuit with respect to the
                        Services.</p> {`YOU   AND   EZPRO   AGREE   THAT   EACH   OF   YOU   MAY   BRING   CLAIMS AGAINST THE OTHER ONLY IN YOUR OR ITS INDIVIDUAL CAPACITY AND NOT AS A PLAINTIFF OR CLASS   MEMBER   IN   ANY   PURPORTED   CLASS   OR REPRESENTATIVE ACTION. 

Unless both you and ezPro agree, no arbitrator or judge may consolidate more than one person’s
claims or otherwise preside over any form of a representative or class proceeding.   The court
may award injunctive relief only in favor of the individual party seeking relief and only to the
extent necessary to provide relief warranted by that party’s individual claim.`}</p>



                    <p style={{...textUnderline, ...mb10}}>16. Arbitration and Dispute Resolution</p>
                    <p>
                        Certain portions of this Section 16 are deemed to be a “written agreement to arbitrate” pursuant
                        to the Federal Arbitration Act.  You and ezPro agree that we intend that this Section 16 satisfies
                        the “writing” requirement of the Federal Arbitration Act.
                    </p>
                    <p>
                        <p style={textBold}> A. First – Try to Resolve Disputes and Excluded Disputes.  </p>
                        If   a   Dispute   or
                        Excluded Dispute arises, which includes those actions set forth herein, then each of ezPro and
                        you agrees to send a written notice to the other providing a reasonable description of the Dispute
                        or Excluded Dispute, along with a proposed resolution of it.  “Dispute” refers to any controversy,
                        allegation, or claim that arises out of or relates to the Platform, these Terms of Use, or any
                        additional   terms,   whether   heretofore   or   hereafter   arising.     “Excluded   Dispute”   refers   to   any
                        controversy, allegation, or claim that arises out of or relates any of ezPro’s actual or alleged
                        intellectual property rights, whether heretofore or hereafter arising.   Our notice to you will be
                        sent to you based using the most recent contact information that you provide to us; if no such
                        information   has   been   provided   or   if   such   information   is   not   current,   then   we   owe   you   no
                        obligation under this Section.   Your notice to Us must be sent to: PoM Home Services, Inc.,
                        Attn:   Legal,   9630   Bruceville   Rd.,   Ste.   106-281,   Elk   Grove,   CA   95757   with   a   copy   to
                        admin@ezprohome.com.  For a period of sixty (60) days from the date of receipt of notice from
                        the other party, ezPro and you will engage in a dialogue in order to attempt to resolve the
                        Dispute or Excluded Dispute, though nothing will require either you or ezPro to resolve the
                        Dispute or Excluded Dispute on terms with respect to which you and ezPro, in each of our/your
                        sole discretion, are not comfortable.
                    </p>
                    <p>
                        <p style={textBold}> Forums for Alternative Dispute Resolution.</p> If you are located in, are based in,
                        have offices in, or do business in a jurisdiction in which this Section  16  is enforceable, the
                        following mandatory arbitration provisions apply to you:
                    </p>

                    <p>(i) <p style={textBold}>Arbitration. </p>{`If we cannot resolve a Dispute as set forth in Section  16(A) within sixty
(60) days of receipt of the notice, then either you or we may submit the Dispute to formal
arbitration.  If we cannot resolve an Excluded Dispute as set forth in Section 16(A) within
60 days of receipt of the notice, then either you or we may submit the Excluded Dispute
to formal arbitration only if you and ezPro consent, in a writing signed by you and an
officer   or   legal   representative   of   ezPro,   to   have   that   Excluded   Dispute   subject   to
arbitration.   In such a case, (and only in such a case), that Excluded Dispute will be
deemed a “Dispute” for the remainder of this Section 16(B).

Upon expiration of the applicable 60-day period and to the fullest extent permitted by
applicable law, a Dispute will be resolved solely by binding arbitration in accordance
with   the   then-current   Comprehensive   Arbitration   Rules   &   Procedures   of   Judicial
Arbitration and Mediation Services, Inc. (“JAMS”).  If the Dispute has a claimed value of
not more than $250,000, then the arbitration will be heard and determined by a single
neutral arbitrator who is a retired judge or a lawyer with not less than fifteen (15) years’
experience as a practicing member of the bar in the substantive practice area related to
the Dispute, who will administer the proceedings.  If the Dispute has a claimed value of
more   than   $250,000,   or   if   ezPro   elects,   in   its   sole   discretion,   to   bear   the   costs   of
arbitration in excess of those that would occur for a proceeding before a single neutral
arbitrator, then the arbitration will be heard and determined by a three-member panel,
with one member to be selected by each party and the third (who will be chair of the
panel) selected by the two party-appointed members or by JAMS in accordance with the
then-current   Comprehensive   Arbitration   Rules   &   Procedures.     The   arbitrator   or
arbitration panel, as the case may be, will apply applicable law, the provisions of these
Terms of Use, and any additional terms set forth in ezPro’s Privacy Policy to resolve any
Dispute.  Such resolution shall be made according to the applicable law and facts and will
issue a reasoned award on no other basis. If you and ezPro do not both consent to the
arbitration of an Excluded Dispute as set forth in the immediately preceding paragraph of
this Section  16(B)(i), then this paragraph and the remainder of this Section  16  will not
apply to the Excluded Dispute.

If   a   party   properly   submits   a   Dispute   to   JAMS   for   formal   arbitration   and   JAMS   is
unwilling or unable to set a hearing date within 60 days of the filing of a “demand for
arbitration,”   then   either   party   can   elect   to   have   the   arbitration   administered   by   the
American   Arbitration   Association   (“AAA”)   using   AAA’s   then-existing   Commercial
Arbitration Rules, or by any other arbitration administration site that You and an officer
or   legal   representative   of   ezPro   consent   to   in   writing.   The   substantive   practice   area
requirements for the arbitrator and the $250,000 threshold for the number of arbitrators
assigned to the Dispute set forth in the paragraph above for the JAMS arbitration will
also apply to any such arbitration under AAA or another arbitration site.
You can obtain JAMS and AAA procedures, rules, and fee information as follows:

      JAMS: 949.224.1810 http://www.jamsadr.com
      AAA:800.778.7879 http://wwwadr.org
`}</p>

                    <p>(ii) <p style={textBold}>Nature, Limitations, and Location of Alternative Dispute Resolution. </p>{`In arbitration,
as with a court, the arbitrator must honor the terms of these Terms of Use (and any
additional terms) and can award the prevailing party damages and other relief (including
attorneys’  fees).    However,  WITH  ARBITRATION  (A)  THERE   IS  NO  JUDGE   OR
JURY, (B) THE ARBITRATION PROCEEDINGS AND ARBITRATION OUTCOME
ARE   SUBJECT   TO   CERTAIN   CONFIDENTIALITY   RULES,   AND   (C)   JUDICIAL
REVIEW   OF   THE   ARBITRATION   OUTCOME   IS   LIMITED.     All   parties   to   the
arbitration will have the right, at their own expense, to be represented by an attorney or
other advocate of their choosing. If an in-person arbitration hearing is required, then it
will be conducted in the City and County of Los Angeles, California. You and ezPro will
pay   the   administrative   and   arbitrator’s   fees   and   other   costs   in   accordance   with   the
applicable arbitration rules; but if applicable arbitration rules or laws require ezPro to pay
a   greater   portion   or   all   of   such   fees   and   costs   in   order   for   this   Section  16  to   be
enforceable, then ezPro will have the right to elect to pay the fees and costs and proceed
to arbitration, or to decline to do so and have the matter resolved through the courts.
Discovery will be permitted pursuant to the applicable arbitration rules.  The arbitrator’s
decision must consist of a written statement stating the disposition of each claim of the
Dispute, and must provide a statement of the essential findings and conclusions on which
the decision and any award (if any) is based.  Judgment on the arbitration decision and
award (if any) may be entered in or by any court that has jurisdiction over the parties
pursuant to the Federal Arbitration Act.`}</p>

                    <p style={{...textUnderline, ...mb10}}>17. Disclaimers </p>
                    <p>{`The Platform is provided “as is” and “as available,” without warranty of any kind.  We do not
warrant that the Platform will meet your requirements; that your access to the Platform will be
uninterrupted, timely, secure, or error-free; that the information provided through the Platform is
accurate, reliable or correct; that any defects or errors will be corrected; that the Platform will be
available at any particular time or location; or that the Platform is free of viruses or other harmful
components.  You assume full responsibility and risk of loss resulting from your downloading
and/or use of files, information, content, or other material obtained from the Platform.
We make no promises or guarantees about the Platform.   Without limiting this, we expressly
disclaim all warranties, whether express, implied or statutory, regarding the Platform including
without limitation any warranty of merchantability, fitness for a particular purpose, title, security,
accuracy, and/or non-infringement`}</p>

                    <p>
                        <p style={textBold}>Not a General Contractor. </p>
                        ezPro is a reservation service and is not a contractor as defined by
                        Section 7026 of the California Business and Professions Code or any other applicable state laws.
                        ezPro does not engage in construction activities, including repairs, alteration, demolition, etc.
                    </p>



                    <p style={{...textUnderline, ...mb10}}>18. Limitation of Liability</p>
                    <p>
                        {
                            `We will not be liable for damages or losses arising from your use or inability to use the Platforms
  or otherwise arising under these Terms of Use.  You understand and agree that we will not be
  liable   to   you   or   any   third   party   for   any   loss   of   profits,   use,   goodwill,   or   data,   or   for   any
  incidental, indirect, special, consequential or exemplary damages, however arising, that result
  from:
  - Your use or inability to use the Platform;
  - Any modification, price change, suspension or discontinuance of the Platform;
  - Unauthorized access to or alterations of Your transmissions or data (except where such 
  disclaimer is expressly prohibited by law);
  - Statements or conduct of any third party on the Platform;
  - Any other interactions that You input or receive through Your use of the Platform; or
  - Any other matter relating to the Platform.
  Our liability is limited whether or not we have been informed of the possibility of such damages,
  and even if a remedy set forth in these Terms is found to have failed of its essential purpose.  We
  will have no liability for any failure or delay due to matters beyond our reasonable control.
  WITHOUT LIMITING THE FOREGOING, IN NO CASE SHALL EZPRO’S LIABILITY FOR
  ANY HARM EXCEED ONE HUNDRED DOLLARS ($100). 
  Because some states or jurisdictions do not allow the exclusion or the limitation of liability for
  consequential or incidental damages, in such states or jurisdictions, ezPro’s liability shall be
  limited to the fullest extent permitted by law.
  We reserve the right, at any time and from time to time, to modify or discontinue, temporarily or
  permanently, the Platform (or any part of it) with or without notice.`
                        }
                    </p>



                    <p style={{...textUnderline, ...mb10}}>19. Indemnity</p>
                    <p>You agree to indemnify, defend, and hold harmless ezPro and its affiliates, officers, directors,
                        employees, consultants, agents, and representatives from any and all third party claims, losses,
                        liability, damages, and/or costs (including reasonable attorney fees and costs) arising from: (i)
                        Your access to or use of the Platform, (ii) your violation of these Terms, or (iii) infringement of
                        any intellectual property or other right of any person or entity or infringement by You or any
                        other user of your account.  ezPro will notify you promptly of any such claim, loss, liability, or
                        demand and will provide you with reasonable assistance, at your expense, in defending any such
                        claim, loss, liability, damage, or cost.</p>


                    <p style={{...textUnderline, ...mb10}}>20. Users Outside of the United States</p>
                    <p>
                        ezPro is hosted and operated entirely in the United States and is subject to United States law.
                        Please do not provide us with any information or attempt to use our Services if you live outside
                        of the United States.  If you are from a jurisdiction outside of the United States and provided us
                        with any information, please notify us so that we may take necessary action.  This may include
                        terminating your account and deleting your information.  We are committed to resolving these
                        issues, so if you have any questions about how we collect or use your information you may email
                        us at admin@ezprohome.com
                    </p>


                    <p style={{...textUnderline, ...mb10}}>21. Changes to These Terms of Use</p>
                    <p>We reserve the right, at our sole discretion, to amend these Terms at any time.  We will notify
                        our you of material changes to these Terms and will also post a notice on the Site.  We want you
                        to be informed of important changes to our Terms, but some changes aren’t that important — we
                        don't want to bother you every time we fix a typo.  So while we may modify these Terms at any
                        time, we will only notify you of any changes that affect your rights.  We reserve the right, at any
                        time and from time to time, to modify or discontinue, temporarily or permanently, the Platform
                        (or any part of it) with or without notice.</p>


                    <p style={{...textUnderline, ...mb10}}>22. Miscellaneous</p>
                    <p style={mb10}><p style={textBold}>Governing Law.</p>Except to the extent applicable law provides otherwise, these Terms of Use
                        between You and ezPro, and any access to or use of the Platform, are governed by the federal
                        laws of the United States of America and the laws of the State of California, without regard to
                        conflict of law provisions.   You and ezPro agree to submit to the exclusive jurisdiction and
                        venue of the courts located in the City and County of Los Angeles, California.</p>

                    <p style={mb10}><p style={textBold}>Section Headings and Summaries.  </p>throughout these Terms of Use, each section includes titles
                        and/or brief summaries of its terms and conditions.  These section titles and brief summaries are
                        not legally binding.</p>

                    <p style={mb10}>
                        <p style={textBold}>Assignment. </p>
                        ezPro may assign its rights under these Terms of Use to any person or entity
                        without Your consent.  The rights granted to you under these Terms of Use may not be assigned
                        without ezPro’s prior written consent, and any attempted unauthorized assignment by you shall
                        be null and void.
                    </p>
                    <p style={mb10}>
                        <p style={textBold}>Severability, No Waiver, and Survival.</p>
                        If any part of these Terms of Use is held invalid or
                        unenforceable, that portion of these Terms of Use will be construed to reflect the parties’ original
                        intent.  The remaining portions will remain in full force and effect.  Any failure on the part of
                        ezPro to enforce any provision of these Terms of Use will not be considered a waiver of our right
                        to enforce such provision.  Our rights under these Terms of Use will survive any termination of
                        these Terms of Use.
                    </p>
                    <p style={mb10}>
                        <p style={textBold}>Amendments; Complete Agreement.  </p>
                        These Terms of Use may only be modified by a written
                        amendment   signed   by   an   authorized   representative   of   ezPro,   or   by   the   posting   of   a   revised
                        version in accordance with Section  21.   These Terms of Use supersede any proposal or prior
                        agreement, oral or written, and any other communications between You and ezPro relating to the
                        subject matter of these Terms of Use, including any confidentiality or nondisclosure agreements.
                    </p>
                    <p style={mb10}>
                        <p style={textBold}>Attorneys’ Fees.</p>
                        n   the   event   any   litigation   or   arbitration   is   brought   by   You   or   ezPro   in
                        connection   with   these   Terms   of   Use,   except   as   otherwise   provided   in   Section  16(B),   the
                        prevailing   party   shall   be   entitled   to   recover   from   the   other   party   all   the   reasonable   costs,
                        attorneys’ fees, and other expenses incurred by such prevailing party in the litigation.
                    </p>
                    <p style={mb10}>
                        <p style={textBold}>Notices.</p>
                        All notices given by you or required under these Terms of Use shall be in writing and
                        sent to PoM Home Services, Inc., Attn: Legal, 9630 Burceville Rd., Ste. 106-281, Elk Grove, CA
                        95757 with a copy to admin@ezprohome.com
                    </p>

                    <p style={{...textUnderline, ...mb10}}>23. Contact Us</p>
                    <p>If You have any questions or comments relating to Platform or these Terms, you can submit a
                        question by sending an email to admin@ezprohome.com or by calling Our Customer Service
                        team at (916) 496-3133.</p>

                    <p style={mt40}>Last updated: June 22, 2022</p>


                </div>
            </div>
        )
    }

    render() {
        return (
            <div>
                <Dialog
                    open={this.props.open}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {/* {this.props.content} */}
                            {this.termOfUseContent()}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={this.props.handleYes}
                            color="primary"
                            autoFocus
                        >
                            Okay
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

export default TermsOfUseAlert;



// WEBPACK FOOTER //
// ./src/components/Alert/TermsOfUseAlert.jsx